import React from "react";
import "./BlockPopUp.scss";
import { dispatchErrorMessage } from "../Common/FileUploadValidation";
import { BlockedInfo, ClosePopup } from "../../../assets/images";
import PropTypes from "prop-types";
export const BlockPopUp = (props = {}) => {
  const { popUpToggleAction, dispatchAction, headerLabel, closeLabel, actionLabel, infoLabel } = props;

  const actionDispatch = () => {
    if (!dispatchErrorMessage()) {
      dispatchAction();
    }
  };

  return (
    <div className="popup-wrapper BlockedPopUp">
      <div className="popup-container">
        <div className="popup-container-inner">
          <div className="popup-label">
            <div className="popup_close">
               <i  onClick={popUpToggleAction}>
                  <ClosePopup />
              </i>
            </div>
            <div className="block_popup_header">
              <h4>{actionLabel} Contact</h4>
              <label>{headerLabel}</label>
            </div>
          </div>
          <div className="popup-noteinfo">
            <button type="button" className="popup btn-cancel" name="btn-cancel" onClick={popUpToggleAction}>
              {closeLabel}
            </button>
            <button type="button" className="popup btn-action" name="btn-action" onClick={actionDispatch}>
              {actionLabel}
            </button>
          </div>
          <div className="blockedInfo">
            <p>
              <i>
                <BlockedInfo style={{fill:'none'}} />
              </i>
              <span>{infoLabel}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

BlockPopUp.propTypes = {
  popUpToggleAction: PropTypes.func,
  dispatchAction: PropTypes.func,
  headerLabel: PropTypes.string,
  closeLabel: PropTypes.string,
  actionLabel: PropTypes.string,
  infoLabel: PropTypes.string,
};